import { TimeReport, TimeReportProject } from "../types";

export const addTimeReportProject = (timeReport: TimeReport, project: TimeReportProject): TimeReport => ({
  ...timeReport,
  projects: [...timeReport.projects, project],
});
